export const getInitials = (name) => name ? name.split(' ').map(w => w[0]).join('').toUpperCase() : 'UN';

export const getColorClass = (name) => {
    const colors = [
        'bg-green-100 text-green-600',
        'bg-pink-100 text-pink-600',
        'bg-red-100 text-red-600',
        'bg-purple-100 text-purple-600',
        'bg-blue-100 text-blue-600',
        'bg-yellow-100 text-yellow-600',
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

export const formatDateForInput = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toISOString().split('T')[0];
};
